<template>
  <page :title="$tc('user._name')+' / '+$tc('feedback.title')" size="is-xlarge">
    <div class="box">
      <b-field>
        <b-input
          type="search"
          icon="magnify"
        :placeholder="$tc('search.publisher')"
          v-model="search"
          @input="onSearch => feedback.filter({ search }).load()"
        ></b-input>
      </b-field>
      <hr />

      <b-table
        :data="feedback.data"
        :loading="feedback.loading"
        ref="table"
        paginated
        per-page="20"
        detailed
        detail-key="id"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" sortable>{{ props.row.id }}</b-table-column>


          <b-table-column field="user.id" label="User ID">
            <template v-if="props.row.user">
              <router-link :to="'/users/' + props.row.user.id">{{ props.row.user.id }}</router-link>
            </template>
            <template v-else>
              <router-link :to="'/devices/' + props.row.device.id">{{ props.row.device.id }}</router-link>
            </template>
          </b-table-column>
          <b-table-column field="user.name" label="Name">
            <template v-if="props.row.user">{{ props.row.user.name}}</template>
            <template v-else>
              {{ props.row.device.os }}
            </template>
          </b-table-column>

          <b-table-column field="email" label="Email">
            <template v-if="props.row.user">{{ props.row.user.email }}</template>
            <template v-else>
              {{ props.row.device.model }}
            </template>
          </b-table-column>

          <b-table-column field="Description" label="Description">
            <div v-if="props.row.description.length<8">{{ props.row.description }}</div>
            <div v-else>{{ props.row.description.substring(0,8)+".." }}</div>
          </b-table-column>

          <b-table-column field="Device" label="Device">{{ props.row.device_id }}</b-table-column>

          <b-table-column field="created_at" label="Created">
            <b-tooltip :label="props.row.created_at">
              <span>{{ calculated(props.row.created_at) }}</span>
            </b-tooltip>
          </b-table-column>


          <b-table-column custom-key="actions" width="300">
            <div class="is-pulled-right">
              <FeedMail > <h1 class="button mr-2" @click="edit(props.row)">
                Reply
              </h1> </FeedMail>
            </div>
          </b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
          <article class="media">
            <figure class="media-left">
              <p class="image is-64x64">
                <img :src="props.row.image_url" />
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <p>
                  <strong>{{ props.row.name }} {{ props.row.email }}</strong>
                  <br />
                </p>
                <div class="columns">
                  <div class="column is-1">
                    <p class="has-text-justified">{{ props.row.type }}</p>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-8">
                    <p class="has-text-justified">{{ props.row.description }}</p>
                  </div>
                </div>
              </div>
            </div>
              <button class="button is-primary" slot="trigger" v-if="props.row.image_url" @click="active = true">
                <b-icon icon="file">
                  <img :src="props.row.image_url" />
                </b-icon>
                <span>Screenshot</span>
              </button>

            <b-modal :active.sync="active" has-modal-card>
              <div class="modal-card">
                <header class="modal-card-head">
                  <p class="modal-card-title">Screenshot</p>
                </header>

                <div class="modal-card-body">
                  <img :src="props.row.image_url">
                </div>

                <footer class="modal-card-foot">
                  <button class="button" type="button" @click="active = false">Close</button>
                </footer>
              </div>
            </b-modal>

          </article>
        </template>
      </b-table>
    </div>
  </page>
</template>
<script>
import FeedbackEmail from "./FeedbackEmail.vue";
import moment from "moment";
import _ from "lodash";
export default {
  Components: {
    FeedMail:FeedbackEmail
  },
  data() {
    return {
      feedback: new window.PaginatedRemoteCollection("/admin/api/feedback"),
      showDetailIcon: true,
      search: this.$route.query.feedbackId,
      active: false,
    };
  },
  created() {
    if (this.search > 0) {
      this.feedback.filter({ search: this.search }).load();
    } else {
      this.feedback.load();
    }
  },
  methods: {
    edit(notification){
      this.$buefy.modal.open(
        {
          component:FeedbackEmail,
          props:{
            notification
          }
        },
      );
    },
    onSearch: _.throttle(function() {
      this.feedback.with({ search: this.search }).load();
    }, 300),
    calculated(created) {
      return moment(created).fromNow();
    },
    clickMe() {
      this.$buefy.notification.open("Clicked!!");
    }
  }
};
</script>
